import { controls } from "../../controls";

const rp803 = {
  label: "Share Statement",
  pageLabel: "Share Statement",
  starting: true,
  url: "rp803",

  pageType: "history",
  filter: [

    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2", displaytype: 'small' }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-6 " }),

    ...controls.displayText({ tab: "filter", label: "Member Type", star: true, width: "col-sm-2" }),
    ...controls.select({
      tab: "filter", name: "member_type", isRequired: true, width: "col-sm-2", placeHolder: "Select", defaultValue: "",
      options: [{
        label: "Regular",
        value: "regular"
      },
      {
        label: "Associated",
        value: "associated"
      },
      {
        label: "Nominal (B-Class)",
        value: "nominal"
      }]
    }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "create", label: "Opening Date", width: "col-sm-2" }),
    ...controls.showData({ tab: "create", data: "opening_date", name: "opening_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),

    ...controls.displayText({ tab: "filter", label: "Member Number", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", name: "member_number", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-8 " }),

    ...controls.displayText({ tab: "filter", label: "From-To Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", name: "date_from", isRequired: true, width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", star: true, width: "col-sm-0 " }),
    ...controls.magicDate({ tab: "filter", name: "date_to", isRequired: true, width: "col-sm-2" }),



  ],

  form: [],

  history: {
    perPage: 10,
    reportHeader: "Share Statement",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [

      {
        Header: "Date",
        accessor: "date"

      },

      {
        Header: "Tr Type",
        accessor: "tr_type",

      },

      {
        Header: "Certificate No",
        accessor: "certificate_no",

      },


      {
        Header: "No From",
        accessor: "no_from",

      },

      {
        Header: "No To",
        accessor: "no_to",

      },

      {
        Header: "No Of Shares",
        accessor: "no_of_shares",

      },

      {
        Header: "Credit",
        accessor: "credit",
        type: "currency"
      },

      {
        Header: "Debit",
        accessor: "debit",
        type: "currency"
      },

      {
        Header: "No Of Shares",
        accessor: "debit",

      },


      {
        Header: "Balance",
        accessor: "balance",
        type: "currency"
      },




    ]
  }
};

export default rp803;